import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable()
export class DomService {
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    rendererFactory: RendererFactory2,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public bodyScrollEnable(): void {
    this.renderer.removeClass(this.document.body, 'overflow-hidden');
  }

  public bodyScrollDisable(): void {
    this.renderer.addClass(this.document.body, 'overflow-hidden');
  }
}
